var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.9 17.1 1.8 1.8c.4-.6.8-1.1 1.2-1.6l-1.6-1.6c.3-.5.5-1.1.5-1.8 0-1.9-1.4-3.6-3.7-3.7-1 0-1.9.4-2.6 1.1-2.9 3 .7 7.8 4.4 5.8zM59 20.9l-1-.6-.9 1.8.7.5c-.5 1.5.1 3.2 1.5 4.2 1.7 1.1 4 .6 5.1-1 1.8-2.7-.6-6.2-3.8-5.6-.6.1-1.2.4-1.6.7zM58.3 14.2c1.1-3.3 2-7 2.6-11.1.1-.4.1-.6.1-.8.1-.4 0-.8-.2-1.1-.3-.3-.7-.4-1.1-.2-.2.1-.7.1-1.3.2-3.8.5-7.3 1.3-10.6 2.4 1.1 5.3 5 9.5 10.5 10.6zM44.6 21c0-1.9-1.6-3.4-3.4-3.4-.9 0-1.8.4-2.4 1s-1 1.5-1 2.4c-.1 4.5 6.8 4.5 6.8 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6 16.1c-6-1.4-10.4-5.9-11.7-11.7-9.8 3.7-17.3 9.9-22.6 18.7h-5.5c-.3 0-.5.1-.7.3L6.7 33.8c-.3.3-.4.7-.2 1.1s.5.6.9.6l10.6.1c-.3 1.2-.7 2.4-.9 3.6-.1.3 0 .7.3.9l4.6 4.6c.2.2.6.3.9.3 1.3-.3 2.5-.6 3.6-.9l.1 10.6c0 .4.3.8.6.9.4.2.8.1 1.1-.2l10.4-10.5c.2-.2.3-.5.3-.7v-5.5c6.5-3.8 14-10.7 18.6-22.6zM33.7 30.2l-6 6c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0s.4 1 0 1.4zm2-9.2c0-3 2.4-5.4 5.4-5.4s5.4 2.4 5.4 5.4-2.4 5.4-5.4 5.4-5.4-2.4-5.4-5.4z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 44.7c-2-2-5.2-2-7.2 0-1.7 1.7-2.9 7.9-3.1 9.2-.1.3 0 .6.3.9.2.2.4.3.7.3h.2c1.2-.2 7.4-1.4 9.1-3.1 2-2.1 2-5.3 0-7.3zM21.1 52.5l-6.3 6.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l6.3-6.3c.4-.4.4-1 0-1.4-.3-.4-1-.4-1.4 0zM9.6 39.6c-.4-.4-1-.4-1.4 0l-6.3 6.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0L9.6 41c.4-.4.4-1 0-1.4zM64.4 50.7l-3.5-1.6 1.3-3.6c.1-.4 0-.8-.2-1l-1.3-1.4c-.3-.3-.7-.4-1.1-.2L56 44.2l-1.6-3.5c-.2-.3-.5-.6-.9-.6h-1.9c-.4 0-.7.2-.9.6l-1.6 3.5-3.6-1.3c-.4-.1-.8 0-1.1.2l-1.3 1.4c-.3.3-.4.7-.2 1.1l1.3 3.6-3.5 1.6c-.4.2-.6.5-.6.9v1.9c0 .4.2.7.6.9l3.5 1.6-1.3 3.6c-.1.4-.1.8.2 1l1.3 1.4c.3.3.7.4 1.1.2l3.6-1.3 1.6 3.5c.2.4.5.6.9.6h1.9c.4 0 .7-.2.9-.6L56 61l3.6 1.3c.4.1.8 0 1.1-.2l1.3-1.4c.3-.3.4-.7.2-1L60.9 56l3.5-1.6c.3-.2.6-.5.6-.9v-1.9c0-.4-.2-.7-.6-.9zm-11.8 5.8c-2.2 0-3.9-1.8-3.9-3.9 0-2.2 1.8-3.9 3.9-3.9 2.2 0 3.9 1.8 3.9 3.9s-1.8 3.9-3.9 3.9zM5.3 56.9c.4.4.4 1 0 1.4l-2.6 2.6c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l2.6-2.6c.3-.4 1-.4 1.4 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/Launch.f51a9b93a530953dc0e075617e6142c1.svg";
export { ForwardRef as ReactComponent };